module.exports = __webpack_public_path__ + "img/375.2a6ee75a.jpg";